/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'drop-arrow': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M27.22 45.49c-1.3 2.01-5.14 2.01-6.44 0-1.3-2.01-19.36-39.15-19.4-39.22A3.64 3.64 0 0 1 4.61 1h38.78a3.64 3.64 0 0 1 3.23 5.27c-.04.07-18.1 37.2-19.4 39.22z"/>'
  }
})
